import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  DailyStatistics,
  DashboardStatisticsParams,
} from '~/features/dashboard/types/dashboard.type';

/**
 * 일별 통계 조회
 * @description 일별 통계를 조회합니다
 * @endpoint GET /admin/dashboard/daily-statistics
 * @param params - 조회 파라미터
 * @returns 일별 통계 목록
 */
export function getDashboardDailyStatisticsApi(params?: DashboardStatisticsParams) {
  return axiosInstance.get<ApiResponse<DailyStatistics[]>>('/admin/dashboard/daily-statistics', {
    params,
  });
}
